import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { appLinksService } from "@/services/appLinksService";
import type { AdminAppLinks } from "@/types/app-links";

export const appLinksKeys = {
  all: ["app-links"] as const,
  admin: () => [...appLinksKeys.all, "admin"] as const,
  current: () => [...appLinksKeys.all, "current"] as const,
};

export const useAdminAppLinks = () =>
  useQuery({
    queryKey: appLinksKeys.admin(),
    queryFn: () => appLinksService.getAdminAppLinks(),
  });

export const useUpdateAdminAppLinks = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AdminAppLinks) =>
      appLinksService.updateAdminAppLinks(data),
    onSuccess: (data) => {
      queryClient.setQueryData(appLinksKeys.admin(), data);
      queryClient.invalidateQueries({ queryKey: appLinksKeys.current() });
    },
  });
};

export const useCurrentUserAppLinks = (enabled: boolean = true) =>
  useQuery({
    queryKey: appLinksKeys.current(),
    queryFn: () =>
      appLinksService.getCurrentUserAppLinks({
        disableToast: true,
      }),
    enabled,
    retry: false,
  });
